import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { ErrorsTypes } from '../types';

const initialState: ErrorsTypes = {
  firstName: '',
  lastName: '',
  zipCode: '',
  email: '',
  phoneNumber: '',
  universalConsent: '',
  ccpa: '',
};

const errorsSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<{ field: string; error: string }>) => {
      const { field, error } = action.payload;
      return { ...state, [field]: error };
    },
    clearError: (state, action: PayloadAction<{ field: string }>) => {
      const { field } = action.payload;
      return { ...state, [field]: '' };
    },
  },
});

export const selectErrors = (state: RootState) => state.errors;
export const { setError, clearError } = errorsSlice.actions;
export default errorsSlice.reducer;
